import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { PillMenu } from "./PillMenu";

const LANGUAGES = [
  { value: "en", label: "English", short: "EN", hint: "English" },
  { value: "hi", label: "हिंदी", short: "हि", hint: "Hindi" },
];

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation("common");
  // i18n.language can carry a region ("en-GB"); match on the base language.
  const value = (i18n.language || "en").split("-")[0];

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem("app-language", language);
  };

  return (
    <PillMenu
      value={value}
      onChange={handleLanguageChange}
      label={t("language", { defaultValue: "Language" })}
      icon={<Languages size={16} />}
      // On phones the pill shows the short code beside the icon.
      shortLabel={LANGUAGES.find((l) => l.value === value)?.short}
      options={LANGUAGES.map((l) => ({
        value: l.value,
        label: l.label,
        hint: l.hint !== l.label ? l.hint : undefined,
        lead: (
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-[rgb(var(--card-muted))] text-[11px] font-semibold text-[rgb(var(--text-secondary))]">
            {l.short}
          </span>
        ),
      }))}
    />
  );
}
